import React, { useEffect } from 'react';

function ComingSoonPage() {
  useEffect(() => {
    document.title = 'Coming Soon - My Town Spotlight';
  }, []);

  return (
    <main className="relative isolate flex min-h-screen items-center justify-center overflow-hidden bg-slate-950 px-6 py-16 text-white">
      <div
        className="absolute inset-0 -z-10 opacity-80"
        aria-hidden="true"
        style={{
          background:
            'radial-gradient(circle at 20% 20%, rgba(37, 99, 235, 0.32), transparent 34%), radial-gradient(circle at 80% 75%, rgba(245, 158, 11, 0.2), transparent 30%)',
        }}
      />
      <div
        className="absolute inset-0 -z-10 opacity-[0.06]"
        aria-hidden="true"
        style={{
          backgroundImage:
            'linear-gradient(rgba(255,255,255,0.8) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.8) 1px, transparent 1px)',
          backgroundSize: '48px 48px',
        }}
      />

      <section className="mx-auto max-w-3xl text-center">
        <div className="mx-auto mb-8 flex h-16 w-16 items-center justify-center rounded-2xl bg-blue-600 text-2xl font-black shadow-2xl shadow-blue-600/30">
          M
        </div>
        <p className="text-sm font-semibold uppercase tracking-[0.28em] text-amber-400">
          My Town Spotlight
        </p>
        <h1 className="mt-5 text-5xl font-bold tracking-tight sm:text-7xl">
          Something local is coming soon.
        </h1>
        <p className="mx-auto mt-6 max-w-xl text-lg leading-8 text-slate-300">
          We&apos;re building a better way to discover local businesses, events,
          deals, and stories in your community.
        </p>
      </section>
    </main>
  );
}

export default ComingSoonPage;
